class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        //FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    //FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    
    //ishi scripts
    document.getElementsByClassName("collection-product-count")[0].innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementsByClassName("collection-product-count")[0].innerHTML;
  	document.getElementsByClassName("collection-product-count")[1].innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementsByClassName("collection-product-count")[0].innerHTML;
  	
    if(document.querySelectorAll("#FacetFiltersFormSidebar").length) {
      if(document.querySelectorAll("#FacetFiltersFormSidebar [type='checkbox']:checked").length) {
      document.querySelector("#FacetFiltersFormSidebar .clear-all").style.display = "inline-block";
      } else {
      document.querySelector("#FacetFiltersFormSidebar .clear-all").style.display = "none";
      }
    }
	setGridLayout();
	setupWishlistButtons();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }	
    //const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const facetsToRender = Array.from(facetDetailsElements);
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
    facetsToRender.forEach((element) => {
      //document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
      document.querySelector('#main-collection-filters').querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;  
    });

    document.querySelector("#FacetFiltersFormSidebar").innerHTML = parsedHTML.querySelector("#FacetFiltersForm").innerHTML;
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }
  
  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    if (target == null) return;
    const countElementSelectors = ['.count-bubble'];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);
      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
      }
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input[type="number"]')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
    this.buildSlider();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.syncSliderFromInputs();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input[type="number"]');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  // Slider visual (duas alças) sincronizado com os campos numéricos De/Para
  // já existentes. Não depende de biblioteca externa — usa dois
  // <input type="range"> sobrepostos, técnica padrão pra range duplo.
  buildSlider() {
    const numberInputs = this.querySelectorAll('input[type="number"]');
    const minInput = numberInputs[0];
    const maxInput = numberInputs[1];
    if (!minInput || !maxInput) return;

    const rangeMin = 0;
    const rangeMax = Number(maxInput.getAttribute('max')) || 0;
    if (!rangeMax) return;

    // Os dois .field (De/Para) são filhos diretos de <price-range
    // class="facets__price">, igual o slider/legendas que a gente insere
    // a seguir — sem agrupar os campos num wrapper próprio, o CSS que
    // deixa os campos lado a lado (.price-range-fields) acabaria tratando
    // slider + legendas + campos como itens do mesmo flex row, encolhendo
    // o slider pra largura zero.
    const fieldsWrapper = document.createElement('div');
    fieldsWrapper.className = 'price-range-fields';
    this.querySelectorAll(':scope > .field').forEach((field) => fieldsWrapper.appendChild(field));

    const wrapper = document.createElement('div');
    wrapper.className = 'price-range-slider';
    wrapper.innerHTML =
      '<div class="price-range-slider__track"></div>' +
      '<div class="price-range-slider__range"></div>' +
      '<input type="range" class="price-range-slider__input price-range-slider__input--min" min="' + rangeMin + '" max="' + rangeMax + '" step="1" value="' + (minInput.value || rangeMin) + '">' +
      '<input type="range" class="price-range-slider__input price-range-slider__input--max" min="' + rangeMin + '" max="' + rangeMax + '" step="1" value="' + (maxInput.value || rangeMax) + '">';

    const labelsWrapper = document.createElement('div');
    labelsWrapper.className = 'price-range-slider__labels';
    labelsWrapper.innerHTML =
      '<span class="price-range-slider__label price-range-slider__label--min"></span>' +
      '<span class="price-range-slider__label price-range-slider__label--max"></span>';

    this.appendChild(fieldsWrapper);
    this.appendChild(wrapper);
    this.appendChild(labelsWrapper);

    this.sliderMin = wrapper.querySelector('.price-range-slider__input--min');
    this.sliderMax = wrapper.querySelector('.price-range-slider__input--max');
    this.sliderRangeTrack = wrapper.querySelector('.price-range-slider__range');
    this.sliderLabelMin = labelsWrapper.querySelector('.price-range-slider__label--min');
    this.sliderLabelMax = labelsWrapper.querySelector('.price-range-slider__label--max');
    this.sliderRangeMin = rangeMin;
    this.sliderRangeMax = rangeMax;

    this.sliderMin.addEventListener('input', () => {
      if (Number(this.sliderMin.value) > Number(this.sliderMax.value)) {
        this.sliderMin.value = this.sliderMax.value;
      }
      minInput.value = this.sliderMin.value;
      this.updateSliderTrack();
    });
    this.sliderMin.addEventListener('change', () => {
      minInput.dispatchEvent(new Event('input', { bubbles: true }));
      minInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    this.sliderMax.addEventListener('input', () => {
      if (Number(this.sliderMax.value) < Number(this.sliderMin.value)) {
        this.sliderMax.value = this.sliderMin.value;
      }
      maxInput.value = this.sliderMax.value;
      this.updateSliderTrack();
    });
    this.sliderMax.addEventListener('change', () => {
      maxInput.dispatchEvent(new Event('input', { bubbles: true }));
      maxInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    this.updateSliderTrack();
  }

  updateSliderTrack() {
    if (!this.sliderRangeTrack) return;
    const span = this.sliderRangeMax - this.sliderRangeMin;
    if (!span) return;
    const minPercent = ((Number(this.sliderMin.value) - this.sliderRangeMin) / span) * 100;
    const maxPercent = ((Number(this.sliderMax.value) - this.sliderRangeMin) / span) * 100;
    this.sliderRangeTrack.style.left = minPercent + '%';
    this.sliderRangeTrack.style.right = (100 - maxPercent) + '%';

    if (this.sliderLabelMin) this.sliderLabelMin.textContent = this.formatPriceLabel(this.sliderMin.value);
    if (this.sliderLabelMax) this.sliderLabelMax.textContent = this.formatPriceLabel(this.sliderMax.value);
  }

  formatPriceLabel(value) {
    const number = Number(value) || 0;
    return 'R$ ' + number.toFixed(2).replace('.', ',');
  }

  syncSliderFromInputs() {
    if (!this.sliderMin || !this.sliderMax) return;
    const numberInputs = this.querySelectorAll('input[type="number"]');
    const minInput = numberInputs[0];
    const maxInput = numberInputs[1];
    if (minInput.value !== '') this.sliderMin.value = minInput.value;
    if (maxInput.value !== '') this.sliderMax.value = maxInput.value;
    this.updateSliderTrack();
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);